module.exports = __webpack_public_path__ + "media/images/blue-girl-c1ab422a045fd6cae4d1ca4b3025d71a.jpg";